import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { apiMethods, apiEndPoints, common } from '@constants/index';
import {
  IBusinessInfoResponse,
  IBusinessInfo,
  IBusinessRevenueFormatted,
  IBusinessRevenue,
  IBusinessRevenueResponse,
  IBusinessExpenseDetailResponse,
  IBusinessExpenseDetail,
} from '@core/models/business.modal';
import { ISlipsFormApiResponse } from '@core/models';

@Injectable()
export class BusinessService {
  constructor(private http: ApiService) {}

  public businessInfoDetails(itrId: number): Observable<IBusinessInfoResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.itr}${apiEndPoints.businessDetails}/${itrId}`,
    });
  }

  public updateBusinessDetails(
    businessInfoData: IBusinessInfo
  ): Observable<IBusinessInfoResponse> {
    const apiPath = `${apiEndPoints.itr}${apiEndPoints.businessDetails}`;
    return this.http.invoke({
      method: !!businessInfoData.id ? apiMethods.patch : apiMethods.post,
      path: !!businessInfoData.id
        ? `${apiPath}/${businessInfoData.itr}`
        : `${apiPath}`,
      body: businessInfoData,
    });
  }

  public businessRevenueDetails(
    itrId: number
  ): Observable<IBusinessRevenueResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.itr}${apiEndPoints.businessRevenue}/${itrId}`,
    });
  }
  public updateBusinessRevenue(
    businessRevenueData: IBusinessRevenue,
    isUpdate = false
  ): Observable<IBusinessRevenueResponse> {
    const apiPath = `${apiEndPoints.itr}${apiEndPoints.businessRevenue}`;
    return this.http.invoke({
      method: isUpdate ? apiMethods.put : apiMethods.post,
      path: isUpdate ? `${apiPath}/${businessRevenueData.itr}` : `${apiPath}`,
      body: businessRevenueData,
    });
  }
  public businessExpenseDetails(
    itrId: number
  ): Observable<IBusinessExpenseDetailResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.itr}${apiEndPoints.businessExpense}/${itrId}`,
    });
  }

  public updateBusinessExpense(
    businessExpenseData: IBusinessExpenseDetail,
    isUpdate = false
  ): Observable<IBusinessExpenseDetailResponse> {
    const apiPath = `${apiEndPoints.itr}${apiEndPoints.businessExpense}`;
    return this.http.invoke({
      method: isUpdate ? apiMethods.put : apiMethods.post,
      path: isUpdate ? `${apiPath}/${businessExpenseData.itr}` : `${apiPath}`,
      body: businessExpenseData,
    });
  }
  public getNaicsSubCategory(naicsId: number): Observable<ISlipsFormApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.itr}${apiEndPoints.naicsSubCategory}`,
      query: {naics_id: naicsId, limit: common.defaultPageLimit}
    });
  }
}
